import { Box, ColorOptions, Loader, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { ExpandAddView } from '../../components/ExpandAddView'
import { List } from '../../components/List'
import { useStores } from '../../data/store'
import { AddNewMappingForm } from './AddNewMappingForm'

type filterType = {
  [key: string]: string
}

const LedgerMapping = () => {
  const [isLoading, setLoading] = useState(false)
  const [isExpand, setIsExpand] = useState(false)
  const [merchant, setMerchant] = useState<any>({})

  const { getMappingList, config } = useStores((store) => ({
    getMappingList: store.ledgerMapping.getMappingList,
    config: store.user.accessConfig,
  }))

  const [listData, setListData] = useState<any>([...getMappingList()])
  const [searchColumnkeys, setSearchColumnKeys] = useState<any>([])

  const onSearch = (data: any) => {
    console.log(data)
  }

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { ID: 'Id' },
    { merchantId: 'Merchant ID' },
    { ledgerAcctNumber: 'Ledger account Number' },
    { mappingStatus: 'Mapping Status' },
  ]

  const navigation = useNavigation()
  const onPress = (item: any) => {
    setMerchant(item)
    navigation.navigate('ledgerDetails', { id: item.ID })
  }

  const exportFile = async (listData: any) => {
    let transformedData: any = []
    const filteredData = listData.map((item: any) => {
      return {
        id: item.ID,
        merchantId: item.merchantId,
        ledgerAcctNumber: item.ledgerAcctNumber,
        mappingStatus: item.mappingStatus,
      }
    })
    transformedData = filteredData.map((item: any) => [
      item.ID,
      item?.merchantId,
      item?.ledgerAcctNumber,
      item?.mappingStatus,
    ])

    const inputKeys = ['id', 'merchantId', 'ledgerAcctNumber', 'mappingStatus']

    XlsxPopulate.fromBlankAsync().then(async (workbook: any) => {
      const data: any = []
      data.push([...inputKeys])

      filteredData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[index]])
      })

      workbook.sheet(0)?.cell('A1')?.value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })

      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = 'merchant_mapping_list_file.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  const getList = () => {
    if (isLoading) {
      return <Loader />
    }
    return (
      <Box>
        <List
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          numOfColumns={4}
          sizeConfig={[1, 2, 2, 1]}
          data={listData}
          onPress={onPress}
          onSearch={onSearch}
          listTitle={'Ledger Mapping List'}
          hrefPath={'ledgerDetails'}
          isColumnSearchEnabled={true}
          getFilteredData={getMappingList}
          exportFile={exportFile}
        />
      </Box>
    )
  }

  const onUpdate = () => {
    setIsExpand(false)
    // lazyGetAll(false)
  }

  return (
    <Box>
      <Text title={'Ledger Mapping'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={24} />
      <ExpandAddView
        children={<AddNewMappingForm id={merchant.ID} onUpdate={onUpdate} isEditable={true} isDeletable={true} />}
        isExpand={isExpand}
        setIsExpand={setIsExpand}
        title={'Add New Mapping'}
      />
      <Spacer direction="vertical" size={16} />
      {getList()}
    </Box>
  )
}

export default LedgerMapping
